import { mediaAPI } from '@/providers/apis/media/media';
import { Vue, Component, Prop } from 'vue-property-decorator';
import ClassificationSubFwForm from './classification-sub-fw-form/classification-sub-fw-form';
import CountinueUpdate from './countinue-update/countinue-update';
import CreateTenant from './create-tenant/create-tenant';
import HierarchyForm from './hierarchy-form/hierarchy-form';

@Component({
    name: 'tenant-creation',
    components: {
        'create-tenant': CreateTenant,
        'classification-sub-fw-form': ClassificationSubFwForm,
        'hierarchy-form': HierarchyForm,
        'countinue-update': CountinueUpdate,
    },
})

export default class TenantCreation extends Vue {

    private activeComponent: any = 'create-tenant';

    private userData: any = {
        createTenant: {},
        subject_classifications: {},
        group_hierarchy: {},
    };

    private onChangeComponent(key: string, isCompleted: any) {
        if (isCompleted) {
            this.dataCreation((callback: any) => {
                if (callback) {
                    this.activeComponent = key;
                }
            });
        } else {
            this.activeComponent = key;
        }
    }

    private onBackParent(key: any) {
        this.$emit('onSwitchComponent', key);
    }

    private async dataCreation(callback: any) {
        const sendData: any = {};
        sendData.subject_classifications = this.userData.subject_classifications;
        sendData.group_hierarchy = this.userData.group_hierarchy;
        sendData.tenant_name = this.userData.createTenant.tenant_name;
        sendData.short_name = this.userData.createTenant.shortName;
        sendData.it_contact_name = this.userData.createTenant.contactName;
        sendData.it_contact_email = this.userData.createTenant.contactEmail;
        sendData.id_contact_no = this.userData.createTenant.contactNumber;
        sendData.location = {};
        sendData.location.country_id = this.userData.createTenant.country;
        if (this.userData.createTenant.state) {
            sendData.location.state = this.userData.createTenant.state;
        }
        if (this.userData.createTenant.tenant_parent_id) {
            sendData.tenant_parent_id = this.userData.createTenant.tenant_parent_id;
        }
        if (this.userData.createTenant.thumbnail instanceof File) {
            // const imageData = await mediaAPI.uploadFile(this.userData.createTenant.thumbnail, 'image');
            // sendData.tenant_logo = imageData.filename;
            sendData.tenant_logo = this.userData.createTenant.thumbnail;
        }
        callback(sendData);
    }

}
